module.exports = __webpack_public_path__ + "media/images/features/refund/eyecatch-flow-4f9aca716105d1e6464734dc0b90a007.png";